// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-spinner-zkl","icon":"Spinner-icon-Qvl","spinnerRotate":"Spinner-spinner-rotate-knH","staticSpinner":"Spinner-staticSpinner-Tpp","label":"Spinner-label-INo"};